import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter, Button, Grid, Box, useColorModeValue, HStack, VStack, Input, Center, Text, GridItem, Textarea, Heading, SimpleGrid, List, ListItem, Flex, ListIcon, Image, RadioGroup, Radio, Stack, Spinner, Badge, Divider, Tabs, TabList, TabPanels, Tab, TabPanel, Switch, useToast, Icon, IconButton, Tooltip } from '@chakra-ui/react';
import { modifyOrder, getOrderDetails, sendReminder } from '../../services/woo'
import SurveyCard from 'views/Dashboard/Profile/components/SurveyCard';
import axios from 'axios';
import { getAllSurveys, API_TOKEN, API_URL } from 'services/surveyService';
import { transformarFecha, getSiteConfig, getCategoryDisplayName } from 'utils/site';
import { useForm, Controller } from "react-hook-form"
import get from 'lodash/get';
import { getSurvey, getSurveyResponse } from 'services/surveyService';
import ModalSurveyResponse from 'components/Modal/ModalSurveyResponse';
import SignatureInput from 'components/Signature';
import { MdLocalPhone, MdLocationCity } from 'react-icons/md';
import { FiChevronLeft, FiChevronRight, FiDownload, FiClock, FiCheck, FiCalendar, FiUser, FiUsers, FiMessageSquare, FiEdit, FiCheckSquare, FiPenTool, FiMapPin } from 'react-icons/fi';
import { getUserAuth } from "services/surveyService";
import { saveDraft, getDraft, deleteDraft, restoreFilesFromDraft, AUTO_SAVE_INTERVAL } from 'services/autoSaveService';
import { syncFormResponseToCustomer, buildResponseDataFromQuestions } from 'services/formSync';
import { normalizeCourseName, codeToDisplayLabel } from 'utils/courseUtils';
import StaffPicker from 'components/Search/StaffPicker';

const ModalAddSurveyResponse = ({
  isOpen,
  onClose,
  customer,
  updateSurveyResponses,
  directAccess = null,
  casoId = null,
  preselectedFormId = null,
  // deferSubmit: en vez de enviar la respuesta al servidor de inmediato,
  // arma el payload (con archivos/firma ya subidos) y lo entrega vía
  // onDraftReady sin crear el survey_response — quien la use decide cuándo
  // (o si) enviarlo de verdad con submitSurveyResponse() de surveyService.
  // No afecta el comportamiento normal de ningún otro llamador del modal.
  deferSubmit = false,
  onDraftReady = null,
  // Solo lo pasa ScannerShell para directAccess="salidas-pedagogicas": la
  // persona ya elegida vía StaffPicker en StudentInfoCard ANTES de abrir este
  // modal, para no volver a pedir "Autorizado por"/"Nombre del responsable"
  // como texto libre acá adentro — se prellenan Y quedan de solo lectura con
  // ese nombre en vez del usuario logueado. No afecta a ningún otro llamador
  // (queda undefined, cae al comportamiento de siempre).
  pedagogicalEncargado = null,
  pedagogicalAuthorizedBy = null,
  // Info de la salida pedagógica que se está firmando (título/motivo y hora
  // límite) — sin esto, una vez adentro del modal se pierde de vista PARA
  // QUÉ salida es la ficha (esa info solo vivía en la tarjeta de atrás,
  // tapada por el modal). Solo lo pasa ScannerShell para salidas-pedagogicas.
  pedagogicalExitInfo = null,
}) => {
    // Chakra color mode
    const textColor = useColorModeValue("gray.500", "gray.300");
    const bgColor = useColorModeValue("gray.100", "gray.600");
    const [surveyNameLoaded, setSurveyNameLoaded] = useState({});
    const [activeComponent, setActiveComponent] = useState(directAccess ? 'loading' : 'loading');
    const [surveySiteList, setSurveySiteList] = useState([]);
    const [loadingSurveys, setLoadingSurveys] = useState(true);
    const datofy_api = {
        url: API_URL,
        token: `${API_TOKEN}`
    }
    
    // Cruzamos el nombre del sitio Woo registrado en API Suscriptions (config) con el slug de la API Surveys
    const [glosario, setGlosario] = useState({ 'Pagos CapitalWeb CL': 'pagos-capitalweb-cl', 'Pagos BlasPascal CL': 'blaspascal', 'Pagos Testing': 'blaspascal' });
    
    const handleGlosario = (valor) => { return glosario[valor] || 'blaspascal'; };
    
    const [siteConfig, setSiteConfig] = useState({});
    const [slugCurrentSite, setSlugCurrentSite] = useState('');
    const site = slugCurrentSite;
    const [userAuth, setUserAuth] = useState({});
    
    // Agrupar surveys por categoría
    const surveysByCategory = useMemo(() => {
        return surveySiteList.reduce((acc, survey) => {
            const category = survey.category || 'Otros';
            if (!acc[category]) {
                acc[category] = [];
            }
            acc[category].push(survey);
            return acc;
        }, {});
    }, [surveySiteList]);
    
    // Obtener categorías disponibles
    const availableCategories = useMemo(() => {
        return Object.keys(surveysByCategory).filter(category =>
            surveysByCategory[category].length > 0
        );
    }, [surveysByCategory]);

    // Ref para rastrear si el componente está montado
    const isMountedRef = useRef(true);
    const timeoutRef = useRef(null);

    useEffect(() => {
        isMountedRef.current = true;

        return () => {
            isMountedRef.current = false;
            // Limpiar timeout al desmontar
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const get_site_config = getSiteConfig()
        const site_config = JSON.parse(get_site_config)
        const slug_current_site = handleGlosario(site_config.name)
        setSlugCurrentSite(slug_current_site);
        setSiteConfig(site_config);

        const fetchSurveys = async (userAuthData = null) => {
            try {
                setLoadingSurveys(true);
                // Pasar userAuth para evitar llamada redundante
                const response = await getAllSurveys(slug_current_site, { userAuth: userAuthData });
                const surveys = response;
                setSurveySiteList(surveys || []);
                
                // Si se especifica un formulario preseleccionado (desde caso específico)
                if (preselectedFormId) {
                    const targetForm = surveys.find(survey =>
                        survey.id === parseInt(preselectedFormId) || survey.id === preselectedFormId
                    );

                    if (targetForm) {
                        handleShowSurveyResponse(targetForm);
                    } else {
                        setActiveComponent('surveyList');
                    }
                }
                // Si se solicita acceso directo con formulario específico (lógica legacy)
                else if (directAccess && typeof directAccess === 'object' && directAccess.id) {
                    // Buscar el formulario específico en la lista
                    const targetForm = surveys.find(survey =>
                        survey.id === directAccess.id || survey.slug === directAccess.slug
                    );

                    if (targetForm) {
                        handleShowSurveyResponse(targetForm);
                    } else {
                        setActiveComponent('surveyList');
                    }
                } else if (directAccess === 'atencion' && surveys && surveys.length > 0) {
                    // Lógica legacy para acceso directo a atención (compatibilidad)
                    const attentionForm = surveys.find(survey =>
                        survey.category === 'atencion' ||
                        survey.name?.toLowerCase().includes('atencion') ||
                        survey.name?.toLowerCase().includes('atención')
                    );

                    if (attentionForm) {
                        handleShowSurveyResponse(attentionForm);
                    } else {
                        setActiveComponent('surveyList');
                    }
                } else if (directAccess === 'casos' && surveys && surveys.length > 0) {
                    // Acceso directo a casos - buscar primer formulario de casos
                    const casoForm = surveys.find(survey =>
                        survey.category === 'casos' || survey.category === 'Casos'
                    );

                    if (casoForm) {
                        handleShowSurveyResponse(casoForm);
                    } else {
                        setActiveComponent('surveyList');
                    }
                } else if (directAccess === 'retiros' && surveys && surveys.length > 0) {
                    // Acceso directo a la ficha de retiro anticipado (Scanner QR)
                    const retiroForm = surveys.find(survey => survey.category === 'retiros');

                    if (retiroForm) {
                        handleShowSurveyResponse(retiroForm);
                    } else {
                        setActiveComponent('surveyList');
                    }
                } else if (directAccess === 'salidas-pedagogicas' && surveys && surveys.length > 0) {
                    // Acceso directo a la ficha de responsable de salida pedagógica (Scanner QR)
                    const salidaPedagogicaForm = surveys.find(survey => survey.category === 'salidas-pedagogicas');

                    if (salidaPedagogicaForm) {
                        handleShowSurveyResponse(salidaPedagogicaForm);
                    } else {
                        setActiveComponent('surveyList');
                    }
                } else if (directAccess === 'salidas-enfermedad' && surveys && surveys.length > 0) {
                    // Acceso directo a la ficha de responsable de salida por enfermedad (Scanner QR)
                    const salidaEnfermedadForm = surveys.find(survey => survey.category === 'salidas-enfermedad');

                    if (salidaEnfermedadForm) {
                        handleShowSurveyResponse(salidaEnfermedadForm);
                    } else {
                        setActiveComponent('surveyList');
                    }
                } else if (!directAccess || directAccess === null) {
                    // Si directAccess es null o undefined, SOLO mostrar lista (NO cargar formulario)
                    setActiveComponent('surveyList');
                } else {
                    // Si no es acceso directo o no hay surveys, mostrar lista
                    setActiveComponent('surveyList');
                }
            } catch (error) {
                setSurveySiteList([]); // Asegurar que sea un array vacío en caso de error
                setActiveComponent('surveyList');
            } finally {
                setLoadingSurveys(false);
            }
        };

        // Obtener user auth una sola vez y pasarlo a fetchSurveys
        const userAuth = async () => {
            try {
                const user = await getUserAuth(); // Usa cache si está disponible
                setUserAuth(user);
                
                // Pasar user a fetchSurveys para evitar segunda llamada getUserAuth
                await fetchSurveys(user);
            }
            catch (error) {
              // Hacer fetchSurveys sin user auth si falla
              await fetchSurveys();
            }
          };
          userAuth();
    }, [isOpen, directAccess]);
    
    // Resetear estado cuando el modal se cierre
    useEffect(() => {
        if (!isOpen) {
            setActiveComponent('loading');
            setSurveyNameLoaded({});
            setLoadingSurveys(true);
            setSurveySiteList([]);
            setSavedResult(null);
        }
    }, [isOpen]);

        
    // Ficha recién guardada: se muestra en ModalSurveyResponse en lugar de volver al listado
    const [savedResult, setSavedResult] = useState(null); // { surveyRes, data }

    const handleSurveySaved = async (surveyRes) => {
        const responseId = surveyRes?.survey_response?.id;
        setSavedResult({ surveyRes, data: null });
        try {
            const fullResponse = await getSurveyResponse(responseId);
            if (isMountedRef.current) setSavedResult({ surveyRes, data: fullResponse });
        } catch (error) {
            if (isMountedRef.current) {
                setSavedResult({ surveyRes, data: { error: 'La ficha se guardó, pero no se pudo cargar para mostrarla' } });
            }
        }
    };

    // Al cerrar la ficha completada recién se notifica al padre (refresco) y se cierra el flujo
    const handleSavedViewerClose = () => {
        const surveyRes = savedResult?.surveyRes;
        setSavedResult(null);
        updateSurveyResponses?.(surveyRes);
        onClose();
    };

    const FormFieldCreator = () => {
        const [fields, setFields] = useState([]);
        const [fieldName, setFieldName] = useState('');
        const {
            register,
            handleSubmit,
            watch,
            setValue,
            formState: { errors },
          } = useForm();

        const handleFieldNameChange = (event) => {
            setFieldName(event.target.value);
        };
        
        const handleAddField = (fieldName, fieldType) => {
            setFields(prevFields => [...prevFields, { text: fieldName, type: fieldType ? fieldType : 'text' }]);
            setFieldName('');
        };
        
        const onSubmit = async (data, e) => {
            e.preventDefault();
            // Resto de tu código
            alert(JSON.stringify(data, null, 2));
            const response = await handleSave(data);
        };

        const handleSave = async (data) => {
            if (window.confirm('¿Desea guardar el formulario?')) {
                // Crear formulario asociado al sitio
                try {
                    const response = await axios.post( datofy_api.url + '/sites/' + site + '/surveys', data, {
                        headers: {
                            Authorization: `Bearer ${datofy_api.token}`,
                        },
                    });
                    alert('Form saved successfully');
                    return response;
                } catch (error) {
                    alert('Error saving form');
                }
            } else {
                // Close the alert
            }
        };

        const handleRemoveField = (indexToRemove) => {
            setFields(prevFields => prevFields.filter((_, index) => index !== indexToRemove));
        };   

        const surveyName = watch("survey_name");

        useEffect(() => {
        setValue("sections[0].section_name", surveyName);
        }, [surveyName, setValue]);

        return (
            <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Input {...register("survey_name", { required: true, maxLength: 60 } )} placeholder={'Nombre de la encuesta'} mb={6} isInvalid={errors.survey_name ? true : false} />
                {/* Resto del formulario */}
                <VStack spacing={2}>
                  <HStack spacing={2}>
                    <Input 
                      placeholder='Nombre del campo' 
                      value={fieldName} 
                      onChange={handleFieldNameChange} 
                    />
                    <Button onClick={() => handleAddField(fieldName)}>+</Button>
                  </HStack>
                  {fields.map((field, index) => (
                    <HStack key={index} spacing={2} alignItems="flex-start" width="full">
                      <VStack spacing={1} flex={2}>
                        <Input 
                          defaultValue={field.text} 
                          {...register(`sections[0].questions[${index}].text`, { required: true })} 
                          isInvalid={errors.sections && errors.sections[0] && errors.sections[0].questions && errors.sections[0].questions[index] && errors.sections[0].questions[index].text ? true : false} 
                          errorBorderColor='red.300' 
                          placeholder="Texto de la pregunta" 
                        />
                        <Input 
                          defaultValue={field.subtext} 
                          {...register(`sections[0].questions[${index}].subtext`)} 
                          placeholder="Subtexto de la pregunta (opcional)" 
                          variant='flushed' 
                          size={'xs'}
                        />
                      </VStack>
                      <HStack flex={1} justifyContent="space-between">
                        <Input 
                          defaultValue={field.type} 
                          variant='flushed' 
                          size={'xs'} 
                          {...register(`sections[0].questions[${index}].type`)} 
                          type='text' 
                        />
                        <Button 
                          size="sm" 
                          colorScheme="red" 
                          variant='outline' 
                          onClick={() => handleRemoveField(index)}
                        >
                          x
                        </Button>
                      </HStack>
                    </HStack>
                  ))}
                  <Button type='submit'>Guardar</Button>
                </VStack>
            </form>
            </>
        );
    };

    const modalContentFormFieldCreator = () => (
        <>
        <ModalHeader><Button onClick={handleBackToList}>Volver</Button> Crear formulario</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
            <FormFieldCreator />
        </ModalBody>
        </>
    );

    const SurveyList = () => {
        if (loadingSurveys) {
            return (
                <Flex justify="center" align="center" py={16}>
                    <VStack spacing={4}>
                        <Spinner size="lg" color="coral.500" thickness="3px" />
                        <Text color="ink.400" fontFamily="jakarta" fontWeight="600">Cargando formularios...</Text>
                    </VStack>
                </Flex>
            );
        }

        if (availableCategories.length === 0) {
            return (
                <Flex justify="center" align="center" py={16}>
                    <VStack spacing={2}>
                        <Text color="ink.400" fontFamily="jakarta" fontWeight="700">No hay formularios disponibles</Text>
                        <Text fontSize="13px" color="ink.400" fontFamily="jakarta">
                            Formularios filtrados por rol: {userAuth?.role || 'usuario'}
                        </Text>
                    </VStack>
                </Flex>
            );
        }

        const SurveyCard = ({ survey }) => (
            <Box
                as="button" type="button" textAlign="left" w="100%"
                bg="white" border="1.5px solid" borderColor="cream.line2"
                borderRadius="16px" p="14px 16px"
                cursor="pointer" transition="all 0.15s"
                _hover={{ borderColor: 'coral.500', boxShadow: '0 4px 16px -6px rgba(239,90,42,.25)' }}
                onClick={() => handleShowSurveyResponse(survey)}
            >
                <Text fontWeight="800" fontSize="14.5px" color="ink.900" fontFamily="jakarta" lineHeight="1.3">
                    {survey?.name}
                </Text>
                {survey?.description && (
                    <Text fontSize="12.5px" color="ink.400" fontFamily="jakarta" fontWeight="500" mt="4px" noOfLines={2}>
                        {survey.description}
                    </Text>
                )}
            </Box>
        );

        if (availableCategories.length === 1) {
            const category = availableCategories[0];
            return (
                <VStack spacing={3} align="stretch" maxW="680px" mx="auto">
                    <Text fontSize="11px" fontWeight="800" textTransform="uppercase" letterSpacing="0.08em"
                        color="ink.400" fontFamily="jakarta">
                        {getCategoryDisplayName(category)}
                    </Text>
                    {surveysByCategory[category].map((survey, idx) => <SurveyCard key={idx} survey={survey} />)}
                </VStack>
            );
        }

        return (
            <Box maxW="800px" mx="auto">
                <Tabs variant="unstyled" size="sm">
                    <TabList
                        bg="white" border="1px solid" borderColor="cream.line"
                        borderRadius="12px" p="4px" display="inline-flex"
                        gap="2px" mb={5} flexWrap="wrap"
                    >
                        {availableCategories.map(category => (
                            <Tab key={category} px="14px" h="32px" borderRadius="9px"
                                fontWeight="700" fontSize="13px" fontFamily="jakarta" color="ink.400"
                                _selected={{ bg: 'coral.500', color: 'white' }}>
                                {getCategoryDisplayName(category)}
                                <Box as="span" ml={2} px="6px" py="1px" borderRadius="999px"
                                    fontSize="11px" fontWeight="800"
                                    bg="rgba(255,255,255,0.25)" color="inherit">
                                    {surveysByCategory[category].length}
                                </Box>
                            </Tab>
                        ))}
                    </TabList>
                    <TabPanels>
                        {availableCategories.map(category => (
                            <TabPanel key={category} px={0} pt={0}>
                                <VStack spacing={3} align="stretch">
                                    {surveysByCategory[category].map((survey, idx) => (
                                        <SurveyCard key={idx} survey={survey} />
                                    ))}
                                </VStack>
                            </TabPanel>
                        ))}
                    </TabPanels>
                </Tabs>
            </Box>
        );
    };

    const modalContentSurveyList = () => (
        <>
        <ModalHeader p={0} borderBottom="1px solid" borderColor="cream.line">
          <Flex h="62px" align="center" gap={3} px={6} bg="white">
            <Text fontSize="16px" fontWeight="800" letterSpacing="-0.01em" fontFamily="jakarta" color="ink.900">
              Nueva ficha — {customer.first_name} {customer.last_name}
            </Text>
            <Box ml="auto">
              <ModalCloseButton position="static" borderRadius="10px" size="sm" />
            </Box>
          </Flex>
        </ModalHeader>
        <ModalBody bg="cream.bg" px={6} py={5}>
            <SurveyList />
        </ModalBody>
        </>
    );

    const SurveyResponse = () => {
        const surveyResponseName = surveyNameLoaded?.slug
        const [uploadError, setUploadError] = useState(false);
        const [messageError, setMessageError] = useState({ show: false, message: '' });
        const [loading, setLoading] = useState({ show: false, message: '', status: null });
        const [uploaded, setUploaded] = useState([]);
        const [sendEmail, setSendEmail] = useState(!['casos', 'doc'].includes(surveyNameLoaded?.category));
        // Override local para "Autorizado por"/"Nombre del responsable" en
        // Salida Pedagógica — arrancan en null (usan la persona elegida en
        // StudentInfoCard, vía props) y se llenan si el operador toca
        // "Cambiar" en el StaffPicker embebido acá adentro.
        const [encargadoOverride, setEncargadoOverride] = useState(null);
        const [authorizedByOverride, setAuthorizedByOverride] = useState(null);
        const source = axios.CancelToken.source();
        const headers = { 'Authorization': 'Bearer ' + datofy_api.token, "content-type": "multipart/form-data" };
        const [files, setFiles] = useState({});

        // 🔒 Estados para auto-guardado
        const [autoSaveEnabled, setAutoSaveEnabled] = useState(true);
        const [lastSaved, setLastSaved] = useState(null);
        const [hasDraftAvailable, setHasDraftAvailable] = useState(false);
        const [lastSaveStats, setLastSaveStats] = useState(null); // Para mostrar detalles del último guardado
        const autoSaveTimerRef = useRef(null);

        // Toast para notificaciones
        const toast = useToast();

        const {
            handleSubmit,
            formState: { errors },
            control,
            getValues,
            register,
            setValue,
            reset,
          } = useForm();

        // 🔒 Función de auto-guardado (memoizada con useCallback)
        const performAutoSave = useCallback(async () => {
            if (!autoSaveEnabled || !surveyNameLoaded?.id) return;

            try {
                const currentValues = getValues();

                // Separar firmas y archivos de las respuestas normales
                const responses = {};
                const signatures = {};
                const signatureUrls = {};
                const formFiles = {};

                Object.entries(currentValues).forEach(([key, value]) => {
                    if (!value || value === '') return;

                    // Detectar firmas (FileList con nombre signature.png)
                    if (value instanceof FileList && value[0]?.name === 'signature.png') {
                        // Firma como FileList
                        signatures[key] = value;
                    } else if (typeof value === 'string' && (value.startsWith('http') || value.startsWith('/'))) {
                        // Firma como URL (absoluta o relativa)
                        signatureUrls[key] = value;
                    } else if (value instanceof FileList) {
                        formFiles[key] = value;
                    } else {
                        responses[key] = value;
                    }
                });

                // Solo guardar si hay datos
                if (Object.keys(responses).length === 0 && Object.keys(signatures).length === 0) {
                    return;
                }

                const result = await saveDraft({
                    userId: customer.username,
                    surveyId: surveyNameLoaded.id,
                    surveySlug: surveyNameLoaded.slug,
                    surveyName: surveyNameLoaded.name,
                    surveyCategory: surveyNameLoaded.category,
                    responses,
                    signatures,
                    signaturesUrls: signatureUrls,
                    files: formFiles,
                    customerData: customer,
                    interviewerData: userAuth,
                    emailSettings: { sendEmail, surveyCategory: surveyNameLoaded.category },
                    apoderadoEmail: { original: customer.email, modified: responses[Object.keys(responses).find(k => responses[k]?.includes('@')) || ''] },
                    surveyMetadata: {
                        surveyId: surveyNameLoaded.id,
                        surveySlug: surveyNameLoaded.slug,
                        surveyName: surveyNameLoaded.name,
                        surveyCategory: surveyNameLoaded.category,
                        totalQuestions: surveyNameLoaded.questions?.length || 0
                    },
                    casoId
                });

                if (result.success) {
                    setLastSaved(new Date());
                    setLastSaveStats({
                        responses: Object.keys(responses).length,
                        signatures: Object.keys(signatures).length + Object.keys(signatureUrls).length,
                        files: Object.keys(formFiles).length
                    });
                }
            } catch (error) {
            }
        }, [autoSaveEnabled, surveyNameLoaded, customer, userAuth, sendEmail, casoId, getValues]);

        const onSubmit = async (data) => {

            // Validación manual de campos email (react-hook-form no persiste errores
            // porque SurveyResponse se remonta en cada render del componente padre)
            const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
            if (surveyNameLoaded?.questions) {
                for (const q of surveyNameLoaded.questions) {
                    const isEmailField = q.type?.name === 'email' ||
                        q.text?.toLowerCase().includes('correo') ||
                        q.text?.toLowerCase().includes('email');
                    const value = data[q.id];
                    if (isEmailField && value && !emailRegex.test(String(value).trim())) {
                        setMessageError({ show: true, message: `El campo "${q.text}" no tiene un formato de email válido` });
                        return;
                    }
                }
            }

            setLoading({ show: true, message: 'Guardando respuesta...' });
            setMessageError({ show: false, message: '' });
            const responses = []
            const filesToUpload = []; // Guardar archivos para subir ANTES de crear survey_response

            try {
                for (const key in data) {
                    // Debug: verificar tipo de dato

                    if (data[key] instanceof FileList && data[key].length > 0) {
                        const files = Array.from(data[key]); // Convertir FileList a Array

                        // Guardar para subir inmediatamente (ANTES de crear survey_response)
                        for (const file of files) {
                            filesToUpload.push({ file, questionId: key });
                        }

                    } else if (data[key] !== undefined && data[key] !== '' && String(data[key]).trim() !== '') {
                        // Si no es un archivo y tiene valor (ignorar espacios en blanco), dar formato a la respuesta de texto
                        const textSurvey = { answer: String(data[key]).trim(), question_id: key }
                        responses.push(textSurvey)
                    }
                }
            } catch (error) {
                alert("Error al guardar la respuesta. Intente nuevamente.");
                setLoading({ show: false, message: '', status: null });
                setMessageError({ show: true, message: 'Error al procesar el formulario' });
                return;
            }

            // Obtener el email del apoderado usando react-hook-form primero, DOM como fallback
            let apoderadoEmail = customer.email; // Fallback al email original

            // Buscar email inteligentemente en los datos del formulario

            // 1. Buscar por cualquier campo que contenga un email válido
            const foundEmailField = Object.entries(data).find(([key, value]) => {
                if (typeof value === 'string' && emailRegex.test(value) && value !== customer.email) {
                    return true;
                }
                return false;
            });

            if (foundEmailField) {
                apoderadoEmail = foundEmailField[1];
            } else {
                // 2. Si no se encontró email válido, buscar por nombres de campo conocidos
                if (surveyNameLoaded && surveyNameLoaded.questions) {
                    const emailQuestion = surveyNameLoaded.questions.find(q =>
                        (q.text.toLowerCase().includes('correo') && q.text.toLowerCase().includes('apoderado')) ||
                        q.text.toLowerCase().includes('email') ||
                        q.type.name === 'email'
                    );

                    if (emailQuestion && data[emailQuestion.id]) {
                        apoderadoEmail = data[emailQuestion.id];
                    }
                }
            }

            // Si no se encontró en los datos del form, intentar con DOM como fallback
            if (apoderadoEmail === customer.email) {
                const apoderadoEmailField = document.querySelector('input[data-name="Correo Apoderado(a)"]');
                if (apoderadoEmailField && apoderadoEmailField.value) {
                    apoderadoEmail = apoderadoEmailField.value;
                } else {

                    // Debug: mostrar qué campos están disponibles
                    const allDataNameFields = document.querySelectorAll('input[data-name]');
                    if (allDataNameFields.length > 0) {
                        const availableFields = Array.from(allDataNameFields).map(field => field.getAttribute('data-name'));
                    } else {
                    }
                }
            }

            // Reemplazar el campo email en el objeto customer
            const updatedCustomer = { ...customer, email: apoderadoEmail };

            // 🔄 NUEVO FLUJO: Subir archivos PRIMERO (antes de crear survey_response)
            if (filesToUpload.length > 0) {
                setLoading({ show: true, message: 'Subiendo archivos...' });

                for (const { file, questionId } of filesToUpload) {
                    try {
                        const formData = new FormData();
                        formData.append(`filenames[${questionId}]`, file);

                        // Subir archivo SIN survey_response_id (se creará después)
                        const uploadResponse = await uploadFiles(formData, customer.username, null);

                        if (uploadResponse) {

                            // Extraer URL del archivo
                            let fileUrl;
                            if (typeof uploadResponse === 'string') {
                                fileUrl = uploadResponse;
                            } else if (typeof uploadResponse === 'object') {
                                fileUrl = uploadResponse.url || uploadResponse.path || uploadResponse.file_path;
                            }

                            if (fileUrl) {
                                // ✅ Mantener URL relativa (esquema original) - buildFileUrl() la convertirá al renderizar

                                // Agregar URL RELATIVA al array responses[] (como siempre se ha hecho)
                                responses.push({
                                    answer: fileUrl,
                                    question_id: questionId
                                });
                            } else {
                                throw new Error('No se pudo extraer URL del archivo subido');
                            }
                        } else {
                            throw new Error('uploadResponse está vacío');
                        }
                    } catch (fileError) {
                        setMessageError({ show: true, message: `Error al subir archivo: ${file.name}` });
                        setLoading({ show: false, message: '', status: null });
                        return; // Detener proceso si falla la subida de archivos
                    }
                }

                setLoading({ show: true, message: 'Guardando respuesta...' });
            }

            const surveyResponse = {
                survey_slug: surveyResponseName,
                answers: responses, // Ahora incluye texto + URLs de archivos
                username: customer.username,
                customer: updatedCustomer,
                caso_id: casoId
            }

            setUploaded(responses);

            if (deferSubmit) {
                if (responses.length === 0) {
                    setMessageError({ show: true, message: 'Debe completar al menos un campo para enviar el formulario' });
                    setLoading({ show: false, message: '', status: null });
                    return;
                }
                if (surveyNameLoaded?.id) {
                    deleteDraft(customer.username, surveyNameLoaded.id, casoId);
                }
                setLoading({ show: false, message: '', status: null });
                onDraftReady?.({
                    payload:     surveyResponse,
                    site,
                    surveySlug:  surveyResponseName,
                    survey:      surveyNameLoaded,
                });
                onClose();
                return;
            }

            if (responses.length > 0) {
                // Sin window.confirm: el diálogo nativo puede quedar bloqueado/suprimido en
                // Chrome/Windows y cancelaba el guardado en silencio. El usuario ya confirmó
                // al presionar "Guardar ficha".
                try {
                    const surveyRes = await newSurveyResponse(surveyResponse);

                    if (surveyRes && surveyRes.survey_response) {

                        // Sincronizar campos relevantes al perfil WooCommerce (matriculas, salud)
                        const SYNC_CATEGORIES = ['matriculas', 'salud'];
                        if (SYNC_CATEGORIES.includes(surveyNameLoaded?.category) && customer?.id) {
                            try {
                                const responseData = buildResponseDataFromQuestions(
                                    surveyNameLoaded.questions,
                                    data
                                );
                                await syncFormResponseToCustomer({
                                    formSlug: surveyNameLoaded.slug,
                                    formCategory: surveyNameLoaded.category,
                                    responseData,
                                    customerId: customer.id
                                });
                            } catch (syncErr) {
                            }
                        }

                        // 🔒 Eliminar draft después de submit exitoso
                        if (surveyNameLoaded?.id) {
                            deleteDraft(customer.username, surveyNameLoaded.id, casoId);
                        }

                        // Mostrar la ficha completada (sin pasar por la lista de formularios)
                        handleSurveySaved(surveyRes);
                    } else {
                        setMessageError({ show: true, message: 'Error al guardar la respuesta' });
                        setLoading({ show: false, message: '', status: null });
                    }
                } catch (saveError) {
                    setMessageError({ show: true, message: 'Error al guardar la respuesta' });
                    setLoading({ show: false, message: '', status: null });
                }
            } else {
                setMessageError({ show: true, message: 'Debe completar al menos un campo para enviar el formulario' });
                setLoading({ show: false, message: '', status: null });
            }

        }

        const uploadFiles = async (formData, username, surveyResponseId = null) => {
            formData.append(`userfound[username]`, username);

            // Si es de categoría casos, SIEMPRE asociar al usuario (para que aparezca en pestaña Archivos)
            // Si no, NO asociar (solo guardar archivo físicamente)
            const isCasos = surveyNameLoaded?.category === 'casos';

            if (isCasos) {
                // Archivos de casos: asociar al usuario
                formData.append(`assign_to_user`, '1');
                // Si tenemos survey_response_id, asociarlo también (opcional, se puede actualizar después)
                if (surveyResponseId) {
                    formData.append(`survey_response_id`, surveyResponseId);
                } else {
                }
            } else {
                // Archivos de otros formularios: NO asociar al usuario (solo retornar URL)
                formData.append(`assign_to_user`, '0');
            }

            try {
                const response = await axios.post(datofy_api.url + "/files", formData, headers);
                const fileUploaded = response.data.data[0];
                return fileUploaded;
            } catch (error) {
                if (typeof setMessageError === 'function') {
                    setMessageError({ show: true, message: "Error al subir el archivo" });
                    setLoading({ show: false, message: '', status: null });
                } else {
                }
                throw new Error("Error al subir el archivo");
            }
        };

        const newSurveyResponse = async (surveyResponse) => {
            try {
                // Agregar el parámetro send_email al objeto surveyResponse
                const surveyResponseWithEmail = {
                    ...surveyResponse,
                    send_email: sendEmail // Usar el estado del switch
                };
                
                const response = await axios.post(
                    datofy_api.url + "/sites/" + site + "/surveys/" + surveyResponseName + "/webhook", 
                    surveyResponseWithEmail, 
                    { cancelToken: source.token }
                );
                return response.data;
            } catch (error) {
                throw error;
            }
        }

        useEffect(() => {
            // RESETEAR FORMULARIO cuando se carga un nuevo survey
            if (surveyNameLoaded && surveyNameLoaded.questions) {
                reset(); // Limpiar todos los campos del formulario anterior

                // Resetear estados adicionales
                setUploaded([]);
                setUploadError(false);
                setMessageError({ show: false, message: '' });
                setLoading({ show: false, message: '', status: null });
                
                // Establecer el estado inicial de sendEmail según la categoría
                setSendEmail(!['casos', 'doc'].includes(surveyNameLoaded.category));
            }

            // Debug: Información del formulario cargado
            if (surveyNameLoaded && surveyNameLoaded.questions) {

                // Mostrar tipos de campos disponibles
                const fieldTypes = [...new Set(surveyNameLoaded.questions.map(q => q.type.name))];

                // Mostrar campos que podrían ser emails
                const potentialEmailFields = surveyNameLoaded.questions.filter(q =>
                    q.text.toLowerCase().includes('correo') ||
                    q.text.toLowerCase().includes('email') ||
                    q.type.name === 'email'
                );
                if (potentialEmailFields.length > 0) {
                }

                // Mostrar campos de archivo
                const fileFields = surveyNameLoaded.questions.filter(q => q.type.name === 'file');
                if (fileFields.length > 0) {
                }
            }

            // Seleccionar los inputs con data-name específicos y establecer sus valores
            const now = new Date();
            const currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
            const rawGroup = customer.meta_data?.find(m => m.key === 'group_name')?.value ?? null;
            const groupLabel = rawGroup ? codeToDisplayLabel(normalizeCourseName(rawGroup)) : '';
            const inputs = [
                { name: 'Alumno', value: `${customer.first_name} ${customer.last_name}` },
                { name: 'Curso', value: groupLabel },
                { name: 'Profesor', value: userAuth ? userAuth.first_name + ' ' + userAuth.last_name : '' },
                { name: 'Correo Apoderado(a)', value: customer.email, required: true },
                { name: "meta_data_extra['survey_interviewer_auth']", value: userAuth ? userAuth.username : '' },
                // "Retiro Anticipado" (Scanner QR) — hora prellenada al momento de
                // abrir la ficha; "Autorizado por" se sugiere con quien inició
                // sesión pero queda editable, porque quien autoriza el retiro no
                // siempre es quien opera el lector.
                { name: 'Hora de salida', value: currentTime },
                // Fallback para "Autorizado por"/"Nombre del responsable" —
                // solo aplica cuando ESTA instancia del modal no recibió
                // pedagogicalAuthorizedBy/pedagogicalEncargado (ej. Retiro
                // Anticipado, que no las pasa): sugerido con el usuario
                // logueado, campo de texto libre normal. Cuando SÍ vienen
                // (Salida Pedagógica), esas preguntas se renderizan como
                // StaffPicker en vez de <input> — ver más abajo el bloque que
                // sincroniza su valor por id de pregunta.
                { name: 'Autorizado por', value: userAuth ? `${userAuth.first_name} ${userAuth.last_name}` : '' },
                { name: 'Nombre del responsable', value: userAuth ? `${userAuth.first_name} ${userAuth.last_name}` : '' },
                // "Motivo de la salida"/"Horario" en Salida Pedagógica — foto
                // congelada de pedagogicalExitInfo al momento de firmar, de
                // solo lectura (igual que Alumno/Profesor). Sin
                // pedagogicalExitInfo (ej. otro survey) quedan vacías y
                // editables, no rompen nada.
                { name: 'Motivo de la salida', value: pedagogicalExitInfo?.title ?? '', readOnly: !!pedagogicalExitInfo?.title },
                { name: 'Horario', value: pedagogicalExitInfo?.endsAt ? `Hasta las ${pedagogicalExitInfo.endsAt}` : '', readOnly: !!pedagogicalExitInfo?.endsAt },
            ];

            inputs.forEach(input => {
                const element = document.querySelector(`input[data-name="${input.name}"]`);
                if (element) {
                    setValue(element.name, input.value);
                    if (input.required) {
                        element.required = true;
                    }
                    if (input.name === 'Alumno' || input.name === 'Profesor' || input.readOnly) {
                        element.style.border = 'none';
                        element.readOnly = true;
                    }
                } else {
                }
            });

            // "Autorizado por"/"Nombre del responsable" en Salida Pedagógica
            // se renderizan como StaffPicker (con opción de "Cambiar"), no
            // como <input data-name>, así que se sincronizan por id de
            // pregunta en vez de DOM query.
            const authorizedByQuestion = surveyNameLoaded?.questions?.find(q => q.text === 'Autorizado por');
            if (authorizedByQuestion) {
                const picked = authorizedByOverride ?? pedagogicalAuthorizedBy;
                if (picked) setValue(`${authorizedByQuestion.id}`, picked.name);
            }
            const responsibleQuestion = surveyNameLoaded?.questions?.find(q => q.text === 'Nombre del responsable');
            if (responsibleQuestion) {
                const picked = encargadoOverride ?? pedagogicalEncargado;
                if (picked) setValue(`${responsibleQuestion.id}`, picked.name);
            }
        }, [setValue, reset, customer, userAuth, surveyNameLoaded, pedagogicalEncargado, pedagogicalAuthorizedBy, encargadoOverride, authorizedByOverride, pedagogicalExitInfo]);

        // 🔒 useEffect para detectar y recuperar drafts existentes
        useEffect(() => {
            if (!surveyNameLoaded?.id || !customer?.username) return;

            const existingDraft = getDraft(customer.username, surveyNameLoaded.id, casoId);

            if (existingDraft) {
                setHasDraftAvailable(true);

                // Siempre se recupera (el draft expira solo a los 7 días): antes se preguntaba con
                // window.confirm y, si se rechazaba o el navegador bloqueaba el diálogo, el borrador
                // se eliminaba. Para descartarlo existe el botón "Cancelar" del formulario.
                {
                    // Restaurar respuestas de texto
                    Object.entries(existingDraft.responses || {}).forEach(([questionId, answer]) => {
                        setValue(questionId, answer);
                    });

                    // Restaurar firmas pequeñas (base64 a FileList)
                    const restoredSignatures = restoreFilesFromDraft(existingDraft.signaturesSmall || {});
                    Object.entries(restoredSignatures).forEach(([questionId, fileList]) => {
                        setValue(questionId, fileList);
                    });

                    // Restaurar firmas pre-subidas (URLs)
                    if (existingDraft.signaturesUrls) {
                        Object.entries(existingDraft.signaturesUrls).forEach(([questionId, url]) => {
                            setValue(questionId, url);
                        });
                    }

                    // Restaurar archivos pequeños (base64 a FileList)
                    const restoredFiles = restoreFilesFromDraft(existingDraft.filesSmall || {});
                    Object.entries(restoredFiles).forEach(([questionId, fileList]) => {
                        setValue(questionId, fileList);
                    });

                    // Advertencia sobre firmas y archivos grandes que deben readjuntarse
                    const largeSignatures = Object.values(existingDraft.signaturesLarge || {});
                    const largeFiles = Object.values(existingDraft.filesLarge || {});
                    const allLargeFiles = [...largeSignatures, ...largeFiles];

                    if (allLargeFiles.length > 0) {
                        const filesCount = allLargeFiles.length;
                        const fileNames = allLargeFiles.slice(0, 2).map(f => f.fileName).join(', ');
                        const moreFiles = filesCount > 2 ? ` y ${filesCount - 2} más` : '';

                        // ✅ Toast de advertencia para archivos grandes
                        toast({
                            title: "Archivos grandes detectados",
                            description: `Por favor vuelve a adjuntar: ${fileNames}${moreFiles}`,
                            status: "info",
                            duration: 6000,
                            isClosable: true,
                            position: "top"
                        });

                    }

                    // Restaurar configuración de email
                    if (existingDraft.emailSettings?.sendEmail !== undefined) {
                        setSendEmail(existingDraft.emailSettings.sendEmail);
                    }

                    setLastSaved(new Date(existingDraft.lastSavedAt));
                }
            }
        }, [surveyNameLoaded?.id, customer?.username, casoId, setValue, toast]); // ✅ Recuperación automática silenciosa para drafts recientes

        // 🔒 useEffect para iniciar auto-guardado automático
        useEffect(() => {
            if (!autoSaveEnabled || !surveyNameLoaded?.id) return;

            // Limpiar timer existente
            if (autoSaveTimerRef.current) {
                clearInterval(autoSaveTimerRef.current);
            }

            // Iniciar auto-guardado cada 10 segundos
            autoSaveTimerRef.current = setInterval(() => {
                performAutoSave();
            }, AUTO_SAVE_INTERVAL);


            // Cleanup al desmontar
            return () => {
                if (autoSaveTimerRef.current) {
                    clearInterval(autoSaveTimerRef.current);
                }
            };
        }, [autoSaveEnabled, surveyNameLoaded?.id, performAutoSave]); // performAutoSave está memoizado con useCallback

        // 🗑️ Función para cancelar y limpiar el formulario
        const handleCancelForm = () => {
            const confirmCancel = window.confirm(
                '¿Estás seguro de que deseas cancelar?\n\n' +
                'Se perderá todo el progreso actual del formulario.'
            );

            if (confirmCancel) {
                // Limpiar formulario
                reset();

                // Eliminar draft si existe
                if (surveyNameLoaded?.id) {
                    deleteDraft(customer.username, surveyNameLoaded.id, casoId);
                }

                // Resetear estados
                setUploaded([]);
                setUploadError(false);
                setMessageError({ show: false, message: '' });
                setLoading({ show: false, message: '', status: null });
                setLastSaved(null);
                setLastSaveStats(null);

                // Toast de confirmación
                toast({
                    title: "Formulario cancelado",
                    description: "Se ha limpiado todo el progreso",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                    position: "top"
                });

                // Volver a la lista de formularios
                handleBackToList();
            }
        };

        // ── V1 helpers ──────────────────────────────────────────────────────────
        const SECTION_ICONS = [FiCalendar, FiUser, FiUsers, FiMessageSquare, FiEdit, FiCheckSquare, FiPenTool];
        const SECTION_COLORS = [
          { bg: 'sky.bg',    color: 'sky.ink'    },
          { bg: 'coral.soft',color: 'coral.700'  },
          { bg: 'mint.bg',   color: 'mint.ink'   },
          { bg: 'lav.bg',    color: 'lav.ink'    },
          { bg: 'butter.bg', color: 'butter.ink' },
          { bg: 'teal.bg',   color: 'teal.ink'   },
          { bg: 'rose.bg',   color: 'rose.ink'   },
        ];
        const groupedSections = surveyNameLoaded?.questions
          ? Object.values(surveyNameLoaded.questions.reduce((acc, q) => {
              (acc[q.section.id] = acc[q.section.id] || []).push(q); return acc;
            }, {}))
          : [];

        return (
            <>
            {/* ── V1 TOPBAR ── */}
            <ModalHeader p={0} borderBottom="1px solid" borderColor="cream.line">
              <Flex h="62px" align="center" gap={3} px={6} bg="white">
                {/* Breadcrumb */}
                <HStack spacing="6px" fontSize="13.5px" fontWeight="600" fontFamily="jakarta" color="ink.400">
                  <Box as="span" cursor="pointer" color="coral.500" _hover={{ color: 'coral.700' }} onClick={handleBackToList}>
                    Fichas
                  </Box>
                  <Icon as={FiChevronRight} boxSize="13px" />
                  <Box as="span" color="ink.700" noOfLines={1} maxW="220px">
                    {customer.first_name} {customer.last_name}
                  </Box>
                  <Icon as={FiChevronRight} boxSize="13px" />
                  <Box as="span" color="ink.700">{surveyNameLoaded?.name}</Box>
                </HStack>

                {/* Auto-save badge */}
                {lastSaved && (
                  <HStack spacing={2} ml={3} flexShrink={0}>
                    <Box as="span" px="9px" py="3px" borderRadius="999px" fontSize="12px" fontWeight="700"
                      bg="mint.bg" color="mint.ink" display="flex" alignItems="center" gap="5px">
                      <Icon as={FiCheck} boxSize="11px" />
                      Guardado {new Date(lastSaved).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })}
                    </Box>
                  </HStack>
                )}

                {/* Email toggle (casos/doc) */}
                {['casos', 'doc'].includes(surveyNameLoaded?.category) && (
                  <HStack spacing={2} ml={3} flexShrink={0}>
                    <Text fontSize="12.5px" fontWeight="600" color="ink.400">Notif. email</Text>
                    <Switch size="sm" isChecked={sendEmail}
                      onChange={(e) => setSendEmail(e.target.checked)} colorScheme="green" />
                  </HStack>
                )}

                {/* Right actions */}
                <HStack spacing={2} ml="auto" flexShrink={0}>
                  <Tooltip label="Exportar PDF">
                    <Button size="sm" variant="outline" borderColor="cream.line2" color="ink.400"
                      borderRadius="11px" fontWeight="700" fontSize="13px"
                      leftIcon={<Icon as={FiDownload} boxSize="13px" />}
                      _hover={{ borderColor: 'coral.500', color: 'coral.700' }}>
                      PDF
                    </Button>
                  </Tooltip>
                  <ModalCloseButton position="static" borderRadius="10px" size="sm" />
                </HStack>
              </Flex>
            </ModalHeader>

            <ModalBody p={0} bg="cream.bg" display="flex" flexDirection="column" overflow="hidden">
              {loading.show && (
                <Flex justify="center" align="center" flex={1}>
                  <Spinner color="coral.500" size="lg" thickness="3px" />
                  <Text ml={3} color="ink.400" fontFamily="jakarta">{loading.message}</Text>
                </Flex>
              )}

              {/* 2-column layout */}
              <Flex flex={1} overflow="hidden">

                {/* ── FORM COLUMN ── */}
                <Box flex={1} minW={0} overflowY="auto" px={6} pt={5} pb="90px">

                  {/* Student mini-card */}
                  <Box bg="white" border="1px solid" borderColor="cream.line" borderRadius="16px"
                    p="13px 16px" mb={4} display="flex" alignItems="center" gap={3}>
                    <Box w="44px" h="44px" borderRadius="50%" bgGradient="linear(140deg, #E8893C, #C56516)"
                      display="flex" alignItems="center" justifyContent="center"
                      fontWeight="700" color="white" fontSize="14px" flexShrink={0}>
                      {(customer.first_name?.[0] || '') + (customer.last_name?.[0] || '')}
                    </Box>
                    <Box flex={1} minW={0}>
                      <Text fontWeight="800" fontSize="15px" letterSpacing="-0.01em" lineHeight="1.2" fontFamily="jakarta">
                        {customer.first_name} {customer.last_name}
                      </Text>
                      <HStack spacing={2} mt="3px" flexWrap="wrap">
                        <Text fontSize="13px" color="ink.400" fontWeight="500">{customer.username}</Text>
                        {customer.email && <Text fontSize="13px" color="ink.400" fontWeight="500">· {customer.email}</Text>}
                      </HStack>
                    </Box>
                    {customer.meta_data?.find(m => m.key === 'group_name')?.value && (
                      <Box as="span" px="10px" py="4px" borderRadius="999px" fontSize="12px" fontWeight="700"
                        bg="sky.bg" color="sky.ink" flexShrink={0}>
                        {customer.meta_data.find(m => m.key === 'group_name').value}
                      </Box>
                    )}
                  </Box>

                  {/* Contexto de la salida que se está firmando — se pierde de
                      vista una vez adentro del modal si no se repite acá. */}
                  {pedagogicalExitInfo && (pedagogicalExitInfo.title || pedagogicalExitInfo.endsAt) && (
                    <Box bg="lav.bg" border="1px solid" borderColor="lav.ink" borderRadius="14px"
                      p="12px 16px" mb={4} display="flex" alignItems="center" gap={3}>
                      <Icon as={FiMapPin} boxSize={4} color="lav.ink" flexShrink={0} />
                      <Box flex={1} minW={0}>
                        {pedagogicalExitInfo.title && (
                          <Text fontWeight="700" fontSize="14px" color="lav.ink" noOfLines={1}>
                            {pedagogicalExitInfo.title}
                          </Text>
                        )}
                        {pedagogicalExitInfo.endsAt && (
                          <Text fontSize="12.5px" color="lav.ink" fontWeight="600" opacity={0.85}>
                            Hasta las {pedagogicalExitInfo.endsAt}
                          </Text>
                        )}
                      </Box>
                    </Box>
                  )}

            <form id="survey-form" onSubmit={handleSubmit(onSubmit)}>
                {groupedSections.map((questions, index) => {
                    const sectionName = questions[0]?.section?.name || `Sección ${index + 1}`;
                    const SectionIcon = SECTION_ICONS[index % SECTION_ICONS.length];
                    const sectionColor = SECTION_COLORS[index % SECTION_COLORS.length];
                    return (
                        <Box key={index} bg="white" border="1px solid" borderColor="cream.line"
                          borderRadius="20px" boxShadow="0 1px 3px rgba(54,38,22,.05)" mb={4} overflow="hidden">
                          {/* Section header */}
                          <Flex align="center" gap={3} px={5} py="13px" borderBottom="1px solid" borderColor="cream.line">
                            <Flex w="34px" h="34px" borderRadius="10px" bg={sectionColor.bg}
                              align="center" justify="center" flexShrink={0}>
                              <Icon as={SectionIcon} boxSize="17px" color={sectionColor.color} />
                            </Flex>
                            <Text fontWeight="800" fontSize="15.5px" letterSpacing="-0.01em" fontFamily="jakarta">
                              {sectionName}
                            </Text>
                          </Flex>
                          {/* Section body */}
                          <Box px={5} py="18px">
                            <Grid templateColumns="repeat(12, 1fr)" gap={4}>
                            {questions.map((question, questionIndex) => (
                                <GridItem colSpan={question.column_width} key={questionIndex}>
                                    {question.type.name !== 'hidden' && <label htmlFor={question.id}>{question.text}</label>}
                                    {question.type.name === 'signature' ? (
                                    <Controller
                                        name={`${question.id}`}
                                        control={control}
                                        defaultValue=""
                                        render={({ field }) => (
                                        <SignatureInput
                                            onChange={(value) => {
                                                field.onChange(value);
                                                setTimeout(() => performAutoSave(), 500);

                                                if (value instanceof FileList && value.length > 0) {
                                                    const file = value[0];
                                                    (async () => {
                                                        try {
                                                            const formData = new FormData();
                                                            formData.append(`filenames[${question.id}]`, file);
                                                            const uploadResponse = await uploadFiles(formData, customer.username, null);

                                                            let fileUrl;
                                                            if (typeof uploadResponse === 'string') {
                                                                fileUrl = uploadResponse;
                                                            } else if (typeof uploadResponse === 'object') {
                                                                fileUrl = uploadResponse.url || uploadResponse.path || uploadResponse.file_path;
                                                            }

                                                            if (fileUrl) {
                                                                field.onChange(fileUrl);
                                                                setTimeout(() => performAutoSave(), 500);
                                                            }
                                                        } catch (err) {
                                                        }
                                                    })();
                                                }
                                            }}
                                            value={field.value}
                                        />
                                        )}
                                    />
                                    ) : (question.text === 'Nombre del responsable' && pedagogicalEncargado) || (question.text === 'Autorizado por' && pedagogicalAuthorizedBy) ? (
                                    // Salida Pedagógica: en vez de texto libre, muestra a la
                                    // persona ya elegida en StudentInfoCard con opción de
                                    // "Cambiar" (mismo StaffPicker, buscando contra usuarios
                                    // reales de datofy-api) — el valor real del formulario se
                                    // sincroniza por id de pregunta en el useEffect de arriba.
                                    <Controller
                                        name={`${question.id}`}
                                        control={control}
                                        defaultValue={question.text === 'Nombre del responsable' ? pedagogicalEncargado.name : pedagogicalAuthorizedBy.name}
                                        render={() => (
                                            <StaffPicker
                                                value={question.text === 'Nombre del responsable'
                                                    ? (encargadoOverride ?? pedagogicalEncargado)
                                                    : (authorizedByOverride ?? pedagogicalAuthorizedBy)}
                                                onSelect={(person) => {
                                                    if (question.text === 'Nombre del responsable') setEncargadoOverride(person);
                                                    else setAuthorizedByOverride(person);
                                                    setValue(`${question.id}`, person?.name ?? '');
                                                }}
                                                placeholder="Buscar…"
                                            />
                                        )}
                                    />
                                    ) : question.type.name === 'textarea' ? (
                                    <Textarea
                                        {...register(`${question.id}`)}
                                        id={question.id}
                                    />
                                    ) : question.type.name === 'radio' ? (
                                    <Controller
                                        name={`${question.id}`}
                                        control={control}
                                        defaultValue=""
                                        render={({ field }) => (
                                            <RadioGroup {...field}>
                                                <Stack direction="row">
                                                    {(question.response_choices && question.response_choices.length > 0) ? (
                                                        question.response_choices.map((option, optionIndex) => (
                                                            <Radio key={optionIndex} value={option.text}>{option.text}</Radio>
                                                        ))
                                                    ) : (
                                                        <Radio value="">No options available</Radio>
                                                    )}
                                                </Stack>
                                            </RadioGroup>
                                        )}
                                    />
                                    ) : question.type.name === 'select' ? (
                                    <select
                                        {...register(`${question.id}`)}
                                        id={question.id}
                                        style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #E2E8F0' }}
                                    >
                                        <option value="">Seleccionar...</option>
                                        {(question.response_choices || []).map((option, optionIndex) => (
                                            <option key={optionIndex} value={option.text}>{option.text}</option>
                                        ))}
                                    </select>
                                    ) : question.type.name === 'checkbox' ? (
                                    <Controller
                                        name={`${question.id}`}
                                        control={control}
                                        defaultValue={[]}
                                        render={({ field }) => (
                                            <Stack direction="column">
                                                {(question.response_choices || []).map((option, optionIndex) => (
                                                    <label key={optionIndex} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                                        <input
                                                            type="checkbox"
                                                            value={option.text}
                                                            checked={(field.value || []).includes(option.text)}
                                                            onChange={(e) => {
                                                                const current = field.value || [];
                                                                if (e.target.checked) {
                                                                    field.onChange([...current, option.text]);
                                                                } else {
                                                                    field.onChange(current.filter((v) => v !== option.text));
                                                                }
                                                            }}
                                                        />
                                                        {option.text}
                                                    </label>
                                                ))}
                                            </Stack>
                                        )}
                                    />
                                    ) : question.type.name === 'file' ? (
                                    // Manejo especial para inputs tipo file
                                    <Input
                                        {...register(`${question.id}`, {
                                            onChange: (e) => {
                                            }
                                        })}
                                        type="file"
                                        data-name={question.text}
                                        id={question.id}
                                        accept="image/*,application/pdf,.doc,.docx"
                                        multiple={false}
                                    />
                                    ) :
                                    (
                                    <>
                                    <Input
                                        {...register(`${question.id}`, (() => {
                                            const isEmailField = question.type.name === 'email' ||
                                                question.text?.toLowerCase().includes('correo') ||
                                                question.text?.toLowerCase().includes('email');
                                            return isEmailField ? {
                                                pattern: {
                                                    value: /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/,
                                                    message: 'Ingresa un email válido'
                                                }
                                            } : {};
                                        })())}
                                        type={question.type.name}
                                        data-name={question.text}
                                        id={question.id}
                                        isInvalid={!!errors[question.id]}
                                    />
                                    {errors[question.id] && (
                                        <Text color="red.500" fontSize="sm" mt={1}>{errors[question.id].message}</Text>
                                    )}
                                    </>
                                    )}
                                </GridItem>
                            ))}
                            </Grid>
                          </Box>
                        </Box>
                    );
                })}

                {messageError.show && (
                  <Box bg="red.50" border="1px solid" borderColor="red.200" borderRadius="12px" p={3} mb={4}>
                    <Text color="red.600" fontSize="13px" fontWeight="600">{messageError.message}</Text>
                  </Box>
                )}

            </form>
            </Box>

            {/* ── RIGHT SIDEBAR ── */}
            <Box w="280px" minW="280px" borderLeft="1px solid" borderColor="cream.line"
              bg="white" overflowY="auto" p={5} flexShrink={0}
              display={{ base: 'none', lg: 'block' }}>

              {/* Form title */}
              <Text fontSize="11px" fontWeight="800" textTransform="uppercase" letterSpacing="0.1em"
                color="ink.400" fontFamily="jakarta" mb="4px">Formulario</Text>
              <Text fontSize="18px" fontWeight="800" letterSpacing="-0.01em" color="ink.900"
                fontFamily="jakarta" mb={3}>{surveyNameLoaded?.name}</Text>

              {/* Sections progress */}
              <Box h="6px" borderRadius="999px" bg="cream.line" overflow="hidden" mb={4}>
                <Box h="100%" borderRadius="999px" bg="coral.500"
                  w={groupedSections.length ? `${Math.round((1 / groupedSections.length) * 100)}%` : '0%'}
                  transition="width 0.3s" />
              </Box>

              <VStack spacing={0} align="stretch" mb={5}>
                {groupedSections.map((questions, index) => {
                  const name = questions[0]?.section?.name || `Sección ${index + 1}`;
                  const isDone = index === 0;
                  const isActive = index === 1;
                  return (
                    <Flex key={index} align="center" gap={2} py="9px"
                      borderBottom="1px solid" borderColor="cream.line"
                      sx={{ '&:last-child': { borderBottom: 'none' } }}>
                      <Box w="22px" h="22px" borderRadius="50%" flexShrink={0} display="flex"
                        alignItems="center" justifyContent="center" fontSize="10px" fontWeight="800"
                        bg={isDone ? 'mint.bg' : isActive ? 'coral.500' : 'cream.bg2'}
                        color={isDone ? 'mint.ink' : isActive ? 'white' : 'ink.400'}
                        border={isDone ? 'none' : isActive ? 'none' : '1.5px solid'} borderColor="cream.line2">
                        {isDone
                          ? <Icon as={FiCheck} boxSize="11px" color="mint.ink" />
                          : <Text>{index + 1}</Text>}
                      </Box>
                      <Text fontSize="13px" fontWeight={isActive ? '800' : '600'}
                        color={isActive ? 'coral.700' : isDone ? 'ink.400' : 'ink.600'}
                        fontFamily="jakarta" noOfLines={1}>{name}</Text>
                    </Flex>
                  );
                })}
              </VStack>

              {/* Auto-save status */}
              {lastSaved && (
                <Box bg="mint.bg" border="1px solid" borderColor="mint.bg" borderRadius="12px" p={3}>
                  <HStack spacing={2}>
                    <Icon as={FiCheck} boxSize="13px" color="mint.ink" />
                    <Text fontSize="12px" fontWeight="700" color="mint.ink" fontFamily="jakarta">
                      Guardado automáticamente
                    </Text>
                  </HStack>
                  {lastSaveStats && (
                    <Text fontSize="11px" color="mint.ink" opacity={0.75} mt="4px" fontWeight="600">
                      {lastSaveStats.responses > 0 && `${lastSaveStats.responses} campos · `}
                      {new Date(lastSaved).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })}
                    </Text>
                  )}
                </Box>
              )}
            </Box>

          </Flex>

          {/* ── BOTTOM ACTION BAR ── */}
          <Box h="66px" bg="white" borderTop="1px solid" borderColor="cream.line"
            display="flex" alignItems="center" px={6} gap={3} flexShrink={0}>
            {lastSaved && (
              <HStack spacing="6px" color="mint.ink" flexShrink={0}>
                <Icon as={FiCheck} boxSize="14px" />
                <Text fontSize="13px" fontWeight="600" fontFamily="jakarta">
                  Borrador guardado {new Date(lastSaved).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })}
                </Text>
              </HStack>
            )}
            <HStack spacing={2} ml="auto" flexShrink={0}>
              <Button h="44px" px={5} borderRadius="12px" variant="outline"
                borderColor="cream.line2" color="ink.400" fontWeight="700" fontSize="14px"
                _hover={{ borderColor: 'ink.400', color: 'ink.700' }} fontFamily="jakarta"
                onClick={handleCancelForm} isDisabled={loading.show}>
                Cancelar
              </Button>
              <Button h="44px" px={6} borderRadius="12px" type="submit" form="survey-form"
                bg="coral.500" color="white" fontWeight="700" fontSize="14px"
                fontFamily="jakarta"
                boxShadow="0 8px 18px -8px rgba(239,90,42,.65)"
                _hover={{ bg: 'coral.600' }}
                isLoading={loading.show} leftIcon={<Icon as={FiPenTool} boxSize="15px" />}>
                Guardar ficha
              </Button>
            </HStack>
          </Box>
            </ModalBody>
            </>
        );
    };

    const handleBackToList = () => {
        // Limpiar el formulario cargado antes de volver
        setSurveyNameLoaded({});
        setActiveComponent('surveyList');
    };

    const handleShowSurveyResponse = (survey) => {

        // Validar que el survey existe y tiene la estructura correcta
        if (!survey || !survey.slug) {
            return;
        }

        // Cargar el formulario INMEDIATAMENTE
        setSurveyNameLoaded(survey);
        setActiveComponent('surveyResponse');
    };


    return (
        <>
        <ModalSurveyResponse
            isOpen={isOpen && !!savedResult}
            onClose={handleSavedViewerClose}
            customer={customer}
            data={savedResult?.data || null}
        />
        <Modal isOpen={isOpen && !savedResult} onClose={onClose} size='full'>
            <ModalOverlay />
            <ModalContent h="100vh" maxH="100vh" m={0} borderRadius={0}>
                {activeComponent === 'loading' ? (
                    <>
                        <ModalHeader p={0} borderBottom="1px solid" borderColor="cream.line">
                          <Flex h="62px" align="center" px={6} bg="white">
                            <Text fontSize="16px" fontWeight="800" letterSpacing="-0.01em" fontFamily="jakarta">Fichas de atención</Text>
                            <Box ml="auto"><ModalCloseButton position="static" borderRadius="10px" size="sm" /></Box>
                          </Flex>
                        </ModalHeader>
                        <ModalBody bg="cream.bg" display="flex" alignItems="center" justifyContent="center">
                            <VStack spacing={4}>
                                <Spinner size="lg" color="coral.500" thickness="3px" />
                                <Text color="ink.400" fontFamily="jakarta" fontWeight="600">Cargando formularios...</Text>
                            </VStack>
                        </ModalBody>
                    </>
                ) : activeComponent === 'formFieldCreator' ? modalContentFormFieldCreator() :
                  activeComponent === 'surveyResponse' ? <SurveyResponse /> :
                  modalContentSurveyList()}
            </ModalContent>
        </Modal>
        </>
    );
};

export default ModalAddSurveyResponse;